import { Collapse } from '@material-ui/core';
import React from 'react';
import {
	BasicButton,
	DateTimePicker,
	Radio,
} from '../../UI';
import { getSecondary } from '../../styles/colors';
import { moment } from '../../containers/App';
import FormRootLayout from './FormRootLayout';
import { NO_FORM_SECTIONS } from '../../utils/constants';
import { getText } from '../../utils/functions';
import BlockTitle from '../../UI/BlockTitle';


const ConfigPortalDates = ({
	portal,
	updateState,
	translate,
}) => {
	const [localState, setLocalState] = React.useState(portal.config && portal.config.portalDates);
	const [disableSave, setDisableSave] = React.useState(false);

	// Devuelve la fecha minima entre la pasada y la actual formateada con toISOString
	const calcMinDate = localIniDate => {
		const now = new Date().toISOString();
		if (localIniDate > now) return localIniDate;
		return now;
	};
	// Devuelve el día actual formateado con toISOString
	const getNow = () => new Date().toISOString();
	// Devuelve un booleano que indica si la fecha en el campo(date1) es correcta o no
	const incorrectDate = (date1, date2) => date1 < date2;

	React.useEffect(() => {
		if (!localState.close.general.date) {
			const today = new Date().toISOString();
			updateState({
				portalDates: {
					open: {
						option: 1,
						general: {
							date: today
						},
						access: {
							date: today
						},
						delegation: {
							date: today
						},
						earlyVote: {
							date: today
						},
						interventions: {
							date: today
						}
					},
					close: {
						option: 1,
						general: {
							date: portal.council.dateStart
						},
						access: {
							date: portal.council.dateStart
						},
						delegation: {
							date: portal.council.dateStart
						},
						earlyVote: {
							date: portal.council.dateStart
						},
						interventions: {
							date: portal.council.dateStart
						}
					}
				}
			});
		}
	}, []);

	React.useEffect(() => {
		setLocalState(portal.config.portalDates);
	}, [portal.config.portalDates]);

	const renderForm = () => (
		<div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
			{/* OPEN */}
			<div>
				<BlockTitle text={'Fechas de apertura'} style={{ fontSize: '1.2rem' }} />
				<div style={{ display: 'flex' }}>
					<div style={{ minWidth: '200px' }}>Apertura general:</div>
					<div>
						{moment(portal?.config?.portalDates?.open?.general?.date).format('DD/MM/YYYY HH:mm:ss')}
					</div>
				</div>
				{Object.values(portal.config.sections)
					.filter(section => !NO_FORM_SECTIONS.includes(section.value) && section.isActive)
					.map(section => (
						<div
							key={section.value}
							style={{ display: 'flex' }}
						>
							<div style={{ minWidth: '200px' }}>{getText(section, translate)}</div>
							<div>
								{moment(
									(localState.open?.[section.value]) ?
										localState.open?.[section.value]?.date
										: portal.council.dateStart
								).format('DD/MM/YYYY HH:mm:ss')}
							</div>
						</div>
					))
				}
			</div>
			<div>
				<Radio
					value={1}
					checked={localState?.open?.option === 1}
					onChange={() => {
						setLocalState(
							{
								...localState,
								open: {
									...localState.open,
									option: 1
								},
							}
						);
					}}
					name="security"
					label={'Establecer una apertura general para el portal'}
				/>
				<div>
					<Collapse in={localState?.open?.option === 1} timeout="auto" unmountOnExit >
						<div>
							<div style={{
								display: 'flex ',
								alignItems: 'center',
								justifyContent: 'space-between'
							}}>
								<div style={{ marginRight: '1em' }}> Hora de apertura</div>
								<div style={{ minWidth: '300px' }}>
									<DateTimePicker
										required
										onChange={date => {
											const newDate = new Date(date);
											const dateString = newDate.toISOString();
											setLocalState(
												{
													...localState,
													open: {
														...localState.open,
														option: 1,
														general: {
															date: dateString
														}
													},
												}
											);
											setDisableSave(incorrectDate(
												(localState.close.general ?
													localState.close.general?.date : portal.council.dateStart),
												dateString
											));
										}}
										minDateMessage={''}
										maxDateMessage={''}
										errorText={incorrectDate(
											(localState?.close?.general ?
												localState?.close?.general?.date : portal?.council?.dateStart),
											(localState?.open?.general ?
												localState?.open?.general?.date : portal?.council?.dateStart)
										) ? 'Fecha o hora incorrecta' : false}
										// acceptText={translate.accept}
										// cancelText={translate.cancel}
										maxDate={localState?.close?.general?.date}
										minDate={getNow()}
										value={localState?.open?.general ?
											localState?.open?.general?.date : portal?.council?.dateStart}
									/>
								</div>
							</div>
						</div>
					</Collapse>
				</div>
			</div>
			<div>
				<Radio
					value={2}
					checked={localState?.open?.option === 2}
					onChange={() => {
						setLocalState({
							...localState,
							open: {
								...localState.open,
								option: 2,
							}
						});
					}}
					name="security"
					label={'Estableces fechas de apertura por sección'}
				/>
				<div>
					<Collapse in={localState?.open?.option === 2} timeout="auto" unmountOnExit >
						<div>
							<div style={{
								display: 'flex ',
								alignItems: 'center',
								justifyContent: 'space-between',
								marginBottom: '1em'
							}}>
								<div style={{ marginRight: '1em' }}> Hora de apertura General</div>
								<div style={{ minWidth: '300px' }}>
									<DateTimePicker
										required
										onChange={date => {
											const newDate = new Date(date);
											const dateString = newDate.toISOString();
											setLocalState({
												...localState,
												open: {
													option: 2,
													general: {
														date: dateString
													}
												}
											});
											setDisableSave(incorrectDate(
												(localState.close.general ?
													localState.close.general?.date : portal.council.dateStart),
												dateString
											));
										}}
										minDateMessage={''}
										maxDateMessage={''}
										errorText={incorrectDate(
											(localState?.close?.general ?
												localState?.close?.general?.date : portal?.council?.dateStart),
											(localState?.open?.general ?
												localState?.open?.general?.date : portal?.council?.dateStart)
										) ? 'Fecha o hora incorrecta' : false}
										// acceptText={translate.accept}
										// cancelText={translate.cancel}
										minDate={getNow()}
										maxDate={localState?.close?.general?.date}
										value={localState?.open?.general ?
											localState?.open?.general?.date : portal?.council?.dateStart}
									/>

								</div>
							</div>
						</div>
						<div>
							{Object.values(portal.config.sections)
								.filter(section => !NO_FORM_SECTIONS.includes(section.value) && section.isActive)
								.map(section => (
									<div
										key={section.value}
										style={{
											display: 'flex ',
											alignItems: 'center',
											justifyContent: 'space-between',
											marginBottom: '1em'
										}}
									>
										<div style={{ marginRight: '1em' }}>Hora de apertura {getText(section, translate)}</div>
										<div style={{ minWidth: '300px' }}>
											<DateTimePicker
												required
												onChange={date => {
													const newDate = new Date(date);
													const dateString = newDate.toISOString();
													setLocalState({
														...localState,
														open: {
															...localState.open,
															option: 2,
															[section.value]: {
																date: dateString
															}
														}
													});
													setDisableSave(incorrectDate(
														(localState.close.general ?
															localState.close?.[section.value]?.date : portal.council.dateStart),
														dateString
													));
												}}
												minDateMessage={''}
												maxDateMessage={''}
												errorText={incorrectDate(
													(localState.close?.[section.value] ?
														localState.close?.[section.value]?.date : portal.council.dateStart),
													(localState.open?.[section.value] ?
														localState.open?.[section.value]?.date : portal.council.dateStart)
												) ? 'Fecha o hora incorrecta' : false}
												// acceptText={translate.accept}
												// cancelText={translate.cancel}
												minDate={getNow()}
												maxDate={localState?.close?.[section.value]?.date}
												value={localState.open?.[section.value] ?
													localState.open?.[section.value]?.date : portal.council.dateStart}
											/>
										</div>
									</div>
								))
							}
						</div>
					</Collapse>
				</div>
			</div>
			{/* CLOSE */}
			<div style={{ marginTop: '2rem' }}>
				<BlockTitle text={'Fechas de cierre'} style={{ fontSize: '1.2rem' }} />
				<div style={{ display: 'flex' }}>
					<div style={{ minWidth: '200px' }}>Cierre general:</div>
					<div>
						{moment(portal.config.portalDates.close.general?.date).format('DD/MM/YYYY HH:mm:ss')}
					</div>
				</div>
				{Object.values(portal.config.sections)
					.filter(section => !NO_FORM_SECTIONS.includes(section.value) && section.isActive)
					.map(section => (
						<div
							key={section.value}
							style={{ display: 'flex' }}
						>
							<div style={{ minWidth: '200px' }}>{getText(section, translate)}</div>
							<div>
								{moment(
									(localState.close?.[section.value]) ?
										localState.close?.[section.value]?.date
										: portal.council.dateStart
								).format('DD/MM/YYYY HH:mm:ss')}
							</div>
						</div>
					))
				}
			</div>
			<div>
				<Radio
					value={1}
					checked={localState.close.option === 1}
					onChange={() => {
						setLocalState(
							{
								...localState,
								close: {
									...localState.close,
									option: 1
								},
							}
						);
					}}
					name="security"
					label={'Establecer un cierre general para el portal'}
				/>
				<div>
					<Collapse in={localState.close.option === 1} timeout="auto" unmountOnExit >
						<div>
							<div style={{
								display: 'flex ',
								alignItems: 'center',
								justifyContent: 'space-between'
							}}>
								<div style={{ marginRight: '1em' }}> Hora de cierre</div>
								<div style={{ minWidth: '300px' }}>
									<DateTimePicker
										required
										onChange={date => {
											const newDate = new Date(date);
											const dateString = newDate.toISOString();
											setLocalState(
												{
													...localState,
													close: {
														...localState.close,
														option: 1,
														general: {
															date: dateString
														}
													},
												}
											);
											setDisableSave(incorrectDate(dateString, localState?.open?.general?.date));
										}}
										minDateMessage={''}
										maxDateMessage={''}
										errorText={incorrectDate(
											(localState.close.general ?
												localState.close.general?.date : portal.council.dateStart),
											localState?.open?.general?.date
										) ? 'Fecha o hora incorrecta' : false}
										// acceptText={translate.accept}
										// cancelText={translate.cancel}
										minDate={calcMinDate(localState?.open?.general?.date)}
										value={localState.close.general ?
											localState.close.general?.date : portal.council.dateStart}
									/>
								</div>
							</div>
						</div>
					</Collapse>
				</div>
			</div>
			<div>
				<Radio
					value={2}
					checked={localState.close.option === 2}
					onChange={() => {
						setLocalState({
							...localState,
							close: {
								...localState.close,
								option: 2,
							}
						});
					}}
					name="security"
					label={'Estableces fechas de cierre por sección'}
				/>
				<div>
					<Collapse in={localState.close.option === 2} timeout="auto" unmountOnExit >
						<div>
							<div style={{
								display: 'flex ',
								alignItems: 'center',
								justifyContent: 'space-between',
								marginBottom: '1em'
							}}>
								<div style={{ marginRight: '1em' }}> Hora de cierre General</div>
								<div style={{ minWidth: '300px' }}>
									<DateTimePicker
										required
										onChange={date => {
											const newDate = new Date(date);
											const dateString = newDate.toISOString();
											setLocalState({
												...localState,
												close: {
													option: 2,
													general: {
														date: dateString
													}
												}
											});
											setDisableSave(incorrectDate(dateString, localState?.open?.general?.date));
										}}
										minDateMessage={''}
										maxDateMessage={''}
										errorText={incorrectDate(
											(localState.close.general ?
												localState.close.general?.date : portal.council.dateStart),
											localState?.open?.general?.date
										) ? 'Fecha o hora incorrecta' : false}
										// acceptText={translate.accept}
										// cancelText={translate.cancel}
										minDate={calcMinDate(localState?.open?.general?.date)}
										value={localState.close.general ?
											localState.close.general?.date : portal.council.dateStart}
									/>

								</div>
							</div>
						</div>
						<div>
							{Object.values(portal.config.sections)
								.filter(section => !NO_FORM_SECTIONS.includes(section.value) && section.isActive)
								.map(section => (
									<div
										key={section.value}
										style={{
											display: 'flex ',
											alignItems: 'center',
											justifyContent: 'space-between',
											marginBottom: '1em'
										}}
									>
										<div style={{ marginRight: '1em' }}>Hora de cierre {getText(section, translate)}</div>
										<div style={{ minWidth: '300px' }}>
											<DateTimePicker
												required
												onChange={date => {
													const newDate = new Date(date);
													const dateString = newDate.toISOString();
													setLocalState({
														...localState,
														close: {
															...localState.close,
															option: 2,
															[section.value]: {
																date: dateString
															}
														}
													});
													setDisableSave(incorrectDate(dateString, localState?.open?.[section.value]?.date));
												}}
												minDateMessage={''}
												maxDateMessage={''}
												errorText={incorrectDate(
													(localState.close?.[section.value] ?
														localState.close?.[section.value]?.date : portal.council.dateStart),
													localState?.open?.[section.value]?.date
												) ? 'Fecha o hora incorrecta' : false}
												// acceptText={translate.accept}
												// cancelText={translate.cancel}
												minDate={calcMinDate(localState?.open?.[section.value]?.date)}
												value={localState.close?.[section.value] ?
													localState.close?.[section.value]?.date : portal.council.dateStart}
											/>
										</div>
									</div>
								))
							}
						</div>
					</Collapse>
				</div>
			</div>
		</div>
	);


	return (
		<FormRootLayout
			form={renderForm()}
			button={
				<BasicButton
					color='white'
					text={translate.save}
					onClick={() => {
						updateState({
							portalDates: localState
						});
					}}
					backgroundColor={{
						backgroundColor: disableSave ? 'grey' : getSecondary(),
						border: `1px solid ${getSecondary()}`,
						boxShadow: 'none',
						color: 'white',
						fontWeight: 'bold'
					}}
					// Comprobar si hai mensajes de error
					disabled={disableSave}
				/>
			}
		/>
	);
};

export default ConfigPortalDates;
